import axios from "./axios-auth";

const getExcludedKeywords = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getexcludedkeywords",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getExcludedKeywords api", err);
      });
  });

const deleteExcludedKeyword = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deleteexcludedkeyword",
      method: "DELETE",
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("deleteExcludedKeyword api", err);
      });
  });

const addExcludedKeyword = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addexcludedkeyword",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("addExcludedKeyword api", err);
      });
  });

export {getExcludedKeywords, deleteExcludedKeyword, addExcludedKeyword}
